export default __webpack_public_path__ + "img/t3.84101cbb.png";